import React, { useState } from "react";
import Layout from "../../components/layout";
import MainBanner from "../../components/pod-case-study/page-main-banner";
import Intro from "../../components/pod-case-study/cs-intro";
import Technology from "../../components/pod-case-study/cs-ecosystem";
import Automation from "../../components/pod-case-study/cs-deliveries";
import Testimonial from "../../components/pod-case-study/cs-testimonial";
import Impact from "../../components/pod-case-study/cs-impact";
import SEO from '../../components/seo';
import FormSection from "../../components/common/templates/form/form-section";
import StickyCTA from "../../components/common/templates/sticky-cta-section";


function SalesmateCaseStudy({ location }) {
  const [isLoaded, setisLoaded] = useState(false);
  return (
    <div onLoad={() => setisLoaded(true)}>
      <Layout addBodyClass="pod-case-study-page-template transparent-header" footerFormType="basic">
        <SEO description="How Rapidops helped manufacturing and logistics unicorn digitally innovate and automate last mile delivery automation?"
          meta={[{ name: "charSet", content: "utf-8" }]}
          title="Last Mile Delivery Automation in Manufacturing and Logistics" />
        <MainBanner />
        <Intro />
        <Technology />
        <Automation />
        <Impact />
        <Testimonial />
        {/*} location={location} className="site-footer-form" />*/}
        {/* <StickyCTA /> */}
      </Layout>
    </div>

  );
}

export default SalesmateCaseStudy;
